// Helper to provide a WebStorageStateStore for react-oidc-context
import { WebStorageStateStore } from "oidc-client-ts";

export function localStorageUserStore() {
  return new WebStorageStateStore({ store: window.localStorage });
}
